import styled from 'styled-components';

const HeaderLogoContainer = styled.div`
  width: auto;
  margin-left: 0;
  margin-right: 40px;
  height: 80px;
  position: relative;
  pointer-events: none;

  .header-logo--img {
    width: 214px;
    height: 38px;
    margin-top: 18px;
  }
  .white-logo {
    position: absolute;
  }

  .commercial {
    width: 220px;
    height: 50px;
    margin-top: 12px;
  }

  a {
    pointer-events: none;
    display: block;
  }

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transform: none;
    transition: none;
    pointer-events: none;
    svg {
      pointer-events: auto;
      transition: none;
    }

    > svg:nth-child(2) {
      opacity: 0 !important;
      visibility: hidden !important;
    }
  }

  .animate-logo {
    height: 150px;
    transition: transform 500ms !important;

    transform: translateY(
      ${({ prevLogoType }) => (prevLogoType === 'Commercial' ? '-94px' : '-87px')}
    );

    @media (max-width: 1450px) {
      transform: translateY(
        ${({ prevLogoType }) => (prevLogoType === 'Commercial' ? '-98px' : '-95px')}
      );
    }

    svg {
      transition: opacity 250ms ease, visibility 1000ms ease 250ms;
    }

    > svg:first-child {
      opacity: 0 !important;
      visibility: hidden !important;
    }
    > svg:last-child {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }

  @media (max-width: 1450px) {
    height: 70px;

    .header-logo--img {
      width: 160px;
      margin-top: 14px;
    }
    .commercial {
      width: 155px;
      height: 37px;
      margin-top: 17px;
    }
  }

  @media (max-width: 1199px) {
    width: auto !important;
  }

  @media (max-width: 430px) {
    margin-right: 0px;
  }

  @media (max-width: 390px) {
    margin: auto 0;
    left: 0;

    .header-logo--img {
      width: 160px;
      max-width: 100%;
    }
  }
`;

export { HeaderLogoContainer };
